import React from 'react';

const SettingsSection = ({ title, description, children, className = '' }) => {
  return (
    <div className={`bg-card rounded-xl p-6 shadow-card ${className}`}>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground mb-2">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default SettingsSection;